// src/utils/idempotency.ts

/**
 * Gera uma chave única para idempotência
 */
export function generateIdempotencyKey(): string {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 15);
    return `${timestamp}-${random}`;
}

/**
 * Armazena chave de idempotência no sessionStorage
 */
export function storeIdempotencyKey(key: string): void {
    sessionStorage.setItem('last_idempotency_key', key);
}

/**
 * Recupera última chave de idempotência
 */
export function getLastIdempotencyKey(): string | null {
    return sessionStorage.getItem('last_idempotency_key');
}

/**
 * Limpa chave de idempotência
 */
export function clearIdempotencyKey(): void {
    sessionStorage.removeItem('last_idempotency_key');
}